
import React from "react";
// import Resumetoolkit from "../Components/Dashboard/Resume-Toolkit/resumetoolkit";
import {
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { Suspense, lazy } from 'react';
import SkeletonL from "../Components/Skeleton/Withlogin";
import SessionTimeoutRedirect from '../Components/Common/SessionTimeoutRedirect'

const CareerResources = lazy(() => import('../Components/Dashboard/Career-Resources/careerResources'));
const AuthCareerResources = () => {
   const useAuth=()=>{
    const user=localStorage.getItem('user_id')
    const token = document.cookie.replace(/(?:(?:^|.*;\s*)token\s*=\s*([^;]*).*$)|^.*$/, '$1');

    if(token){
      return true
    } else {
      localStorage.clear()
      return false
    }
  }
  const auth = useAuth();
  return auth ? <Suspense fallback={<SkeletonL/>}>
  <CareerResources/>
</Suspense> : <SessionTimeoutRedirect />
}
export default AuthCareerResources;


